import { getAllClassEndType } from "@/services/class-end-type.service";

// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  async loadAllClassEndType() {
    return await getAllClassEndType().then((response) => {
      let data = response.data.data;

      data.map((d, index) => {
        d.index = index + 1;
      });

      return data;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
